import styled from 'styled-components'

import { breakpoint } from 'utils'
import Link from 'components/Link'

export const SsoInformationAndFaqWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 36px;
  padding-top: 36px;
  border-top: 1px solid ${({ theme }) => theme.colors.border[1]};
`

export const SsoInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint('sm')`
    align-items: center;
    flex-direction: row;
  `}
`

export const StyledLink = styled(Link)`
  display: block;
  margin-top: 24px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.small};
  &:nth-child(2) {
    margin-top: 12px;
  }
`
